import React, { useContext } from 'react';
import format from 'string-template';

import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import LeadConversationsContext from '../../../../context/LeadConversationsContext/LeadConversationsContext';
import texts from './texts.json';

const LeadClaimTakeoverModal = () => {
  const {
    isPendingTakeover,
    pendingClaimedByUsername,
    confirmTakeover,
    cancelTakeover,
  } = useContext(LeadConversationsContext);

  return (
    <ConfirmDialog
      isOpen={isPendingTakeover}
      onConfirm={confirmTakeover}
      onCancel={cancelTakeover}
      dialogTexts={{
        title: texts.title,
        content: format(texts.content, { name: pendingClaimedByUsername }),
        confirm: texts.confirm,
        cancel: texts.cancel,
      }}
    />
  );
};

export default LeadClaimTakeoverModal;
